import './App.css';
import backgroundImage from './face3bg.png'; // Import the image from src folder
import illustrationImage from './illus.png'; // Import the new image
// import educationImage from './education.png'; // Import the education image
import individualImage from './individual.png';
import coupleImage from './couple.png';
import familyImage from './family.png';
import parentImage from './parent.png'; // Import the parent coaching image
import sessionImage from './session.png'; // Import the session image
import experienceImage from './expereince.png'; // Import the experience image
import bookingImage from './booking.png'; // Import the booking image
import logoImage from './image.png'; // Import the logo image
import React, { useState, useEffect, useRef } from 'react';

// Translations object
const translations = {
  en: {
    // Header
    logo: 'Al-Shifaa',
    aboutUs: 'About Us',
    services: 'Services',
    contactUs: 'Contact Us',
    bookNow: 'Book Now',
    
    // Hero Section
    heroTitle: 'Your Path to Mental Wellness Through Faith',
    heroMessage1: 'Integrating Islamic principles with modern psychological science',
    heroMessage2: 'Using our Deen as a foundation for healing and balance',
    heroMessage3: 'Building strong families through faith-centered relationships',
    bookConsultation: 'Book a Consultation',
    exploreServices: 'Explore Services',
    
    // About Section
    aboutTitle: 'Why I Created Al-Shifaa',
    aboutText1: 'My inspiration for founding Al-Shifaa comes from my deep passion for helping the Muslim community and recognizing the urgent need for a faith-based approach to psychology. The challenges we face as Muslims—whether in marriage, parenting, or personal growth—require a perspective that integrates Islamic principles with modern psychological science.',
    aboutText2: 'Western psychology, while valuable, often does not address the unique religious, ethical, and moral considerations that shape our daily struggles. Islam is a complete way of life, offering profound guidance for emotional and mental well-being. My goal is to help individuals, couples, and families use our Deen as a foundation for healing and balance while incorporating evidence-based psychological practices.',
    aboutText3: 'A strong family begins with a strong couple. When a husband and wife are rooted in faith and mutual understanding, they can cultivate a thriving, harmonious family.',
    
    // Qualifications
    qualificationsTitle: 'My Approach & Qualifications',
    qualificationsIntro: 'What sets my counsel  ling approach apart is my ability to bridge the gap between Islamic wisdom and psychology',
    degree1: 'A degree in Psychological Sciences and Techniques',
    degree2: 'A Master\'s in Clinical Psychology',
    degree3: 'Specialization in Psychotherapy (in progress)',
    
    // Services
    servicesTitle: 'Our Services',
    servicesIntro: 'Comprehensive mental health services tailored to your unique needs and Islamic values',
    individualTherapy: 'Individual Counselling',
    individualDesc: 'One-on-one counselling sessions designed to address personal challenges, emotional difficulties, and spiritual growth.',
    couplesTherapy: 'Couples Counselling',
    couplesDesc: 'Strengthen your marriage through counselling that honors the Islamic foundation of your relationship.',
    familyTherapy: 'Family Counselling',
    familyDesc: 'Build a harmonious family environment grounded in Islamic teachings and values.',
    parentCoaching: 'Parent Training',
    parentDesc: 'Develop effective parenting skills that align with Islamic values and modern child development principles.',
    
    // Special Program
    specialProgramTitle: 'Special Program: Islamic Parent Training Course',
    specialProgramSessions: '10 sessions',
    specialProgramDesc: 'This unique course is designed to help parents correct problematic behaviors in both themselves and their children, creating a truly balanced and harmonious family.',
    programFeature1: 'Faith-centered parenting techniques',
    programFeature2: 'Practical strategies for common challenges',
    programFeature3: 'Building strong parent-child relationships',
    programFeature4: 'Balancing discipline with compassion',
    learnMore: 'Learn More About This Program',
    
    // Experience
    experienceTitle: 'Extensive Experience',
    experienceItem1: 'Children with special needs including autism, ADHD, and learning disabilities',
    experienceItem2: 'Couples & family counselling for both pathological cases and general life struggles',
    experienceItem3: 'Islamic parent training program designed to create balanced, harmonious families',
    experienceItem4: 'Research and clinical practice in neurophysiology and child development',
    experienceIslamic: 'My studies in Quran and Hadith allow me to incorporate authentic Islamic teachings into Counselling, ensuring each session is grounded in Deen to strengthen both mental well-being and faith.',
    
    // Specializations
    specializationsTitle: 'Areas of Specialization',
    specializationsIntro: 'Detailed expertise to address your specific needs with Islamic wisdom',
    neurodivergentTitle: 'Neurodivergent Support',
    neurodivergentDesc: 'Specialized support for individuals with neurodevelopmental conditions (ADHD, Autism) and learning differences (dyslexia, dysgraphia, dysorthographia, dyscalculia, and other learning disabilities). Our approach focuses on understanding unique strengths while providing effective strategies for daily challenges.',
    multiculturalTitle: 'Multicultural Relationships',
    multiculturalDesc: 'Specialized in supporting couples and families from mixed cultural backgrounds, helping them navigate differences and build common ground with understanding.',
    eatingDisordersTitle: 'Eating Disorders',
    eatingDisordersDesc: 'Experience in treating feeding and eating disorders, specifically ARFID (Avoidant/Restrictive Food Intake Disorder) with compassionate, evidence-based approaches.',
    therapeuticTitle: 'Rehabilitative Approaches',
    therapeuticDesc: 'Certified in Neurofeedback and Horticultural Therapy, offering innovative approaches that complement traditional counselling methods.',
    
    // Testimonials
    testimonialsTitle: 'Testimonials',
    testimonialsIntro: 'Real stories of healing and growth from our community',
    
    // Booking
    bookingTitle: 'Session Details & Booking',
    sessionDuration: 'Sessions last 50 minutes',
    sessionPricing: 'All sessions (individual, couples, and family) are the same price – My goal is not financial gain but to help the community thrive in both Dunya and Akhirah',
    freeConsultation: 'Free 15-minute consultation available before committing to full sessions',
    easyScheduling: 'Easy Scheduling',
    schedulingDesc: 'Our integrated calendar system allows you to select appointment times that fit your schedule, with options for both virtual and in-person sessions.',
    getStarted: 'Get Started',
    getStartedDesc: 'Complete the contact form to begin your journey toward mental wellness and spiritual growth.',
    fillForm: 'Fill Out Contact Form',
    
    // Modal Form
    contactForm: 'Contact Form',
    formDescription: 'Please fill out the form below, and I\'ll personally respond to your inquiry within 24 hours, insha\'Allah.',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    message: 'Message',
    messagePlaceholder: 'Please describe what you\'re seeking help with',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    privacyNote: 'Your information is kept private and confidential',
    successMessage: 'Thank you for your message. I will get back to you soon, insha\'Allah.',
    errorMessage: 'There was an error submitting your form. Please try again.',
    
    // Service tags in testimonials
    individualTherapyTag: 'Individual Counselling',
    familyCounselingTag: 'Family Counselling',
    
    // Footer
    footerAboutTitle: 'Al-Shifaa',
    footerAboutText: 'Faith-based psychology integrating Islamic principles with modern science for mental wellness and spiritual growth.',
    footerQuickLinks: 'Quick Links',
    footerContact: 'Contact Information',
    footerEmail: 'Email: info@alshifaaonline.com',
    footerSchedule: 'Schedule a consultation',
    footerCopyright: '© 2025 Al-Shifaa. All rights reserved.',
    footerMadeWith: 'Made with ❤️ for the Muslim community'
  },
  it: {
    // Header
    logo: 'Al-Shifaa',
    aboutUs: 'Chi Siamo',
    services: 'Servizi',
    contactUs: 'Contattaci',
    bookNow: 'Prenota Ora',
    
    // Hero Section
    heroTitle: 'Il Tuo Percorso verso il Benessere Mentale attraverso la Fede',
    heroMessage1: 'Integrando i principi islamici con la scienza psicologica moderna',
    heroMessage2: 'Usando il nostro Deen come fondamento per la guarigione e l\'equilibrio',
    heroMessage3: 'Costruendo famiglie forti attraverso relazioni centrate sulla fede',
    bookConsultation: 'Prenota una Consulenza',
    exploreServices: 'Esplora i Servizi',
    
    // About Section
    aboutTitle: 'Perché ho Creato Al-Shifaa',
    aboutText1: 'La mia ispirazione per fondare Al-Shifaa deriva dalla mia profonda passione nell\'aiutare la comunità musulmana e nel riconoscere l\'urgente necessità di un approccio basato sulla fede alla psicologia. Le sfide che affrontiamo come musulmani—che si tratti di matrimonio, genitorialità o crescita personale—richiedono una prospettiva che integri i principi islamici con la scienza psicologica moderna.',
    aboutText2: 'La psicologia occidentale, pur essendo preziosa, spesso non affronta le considerazioni religiose, etiche e morali uniche che modellano le nostre lotte quotidiane. L\'Islam è un modo di vita completo, che offre una guida profonda per il benessere emotivo e mentale. Il mio obiettivo è aiutare individui, coppie e famiglie a usare il nostro Deen come fondamento per la guarigione e l\'equilibrio, incorporando pratiche psicologiche basate sull\'evidenza.',
    aboutText3: 'Una famiglia forte inizia con una coppia forte. Quando un marito e una moglie sono radicati nella fede e nella comprensione reciproca, possono coltivare una famiglia prospera e armoniosa.',
    
    // Qualifications
    qualificationsTitle: 'Il Mio Approccio e Qualifiche',
    qualificationsIntro: 'Ciò che distingue il mio approccio di consulenza è la mia capacità di colmare il divario tra la saggezza islamica e la psicologia',
    degree1: 'Laurea in Scienze e Tecniche Psicologiche',
    degree2: 'Master in Psicologia Clinica',
    degree3: 'Specializzazione in Psicoterapia (in corso)',
    
    // Services
    servicesTitle: 'I Nostri Servizi',
    servicesIntro: 'Servizi completi di salute mentale su misura per le tue esigenze uniche e i valori islamici',
    individualTherapy: 'Terapia Individuale',
    individualDesc: 'Sessioni di consulenza individuale progettate per affrontare sfide personali, difficoltà emotive e crescita spirituale.',
    couplesTherapy: 'Consulenza di Coppia',
    couplesDesc: 'Rafforza il tuo matrimonio attraverso la consulenza che onora il fondamento islamico della tua relazione.',
    familyTherapy: 'Terapia Familiare',
    familyDesc: 'Costruisci un ambiente familiare armonioso basato sugli insegnamenti e valori islamici.',
    parentCoaching: 'Coaching Genitoriale',
    parentDesc: 'Sviluppa competenze genitoriali efficaci che si allineano con i valori islamici e i principi moderni dello sviluppo infantile.',
    
    // Special Program
    specialProgramTitle: 'Programma Speciale: Corso di Formazione Genitoriale Islamica',
    specialProgramSessions: '10 sessioni',
    specialProgramDesc: 'Questo corso unico è progettato per aiutare i genitori a correggere comportamenti problematici sia in se stessi che nei loro figli, creando una famiglia veramente equilibrata e armoniosa.',
    programFeature1: 'Tecniche genitoriali centrate sulla fede',
    programFeature2: 'Strategie pratiche per le sfide comuni',
    programFeature3: 'Costruire relazioni forti genitore-figlio',
    programFeature4: 'Bilanciare disciplina con compassione',
    learnMore: 'Scopri di Più su Questo Programma',
    
    // Experience
    experienceTitle: 'Esperienza Approfondita',
    experienceItem1: 'Bambini con bisogni speciali inclusi autismo, ADHD e disabilità dell\'apprendimento',
    experienceItem2: 'Consulenza di coppia e familiare sia per casi patologici che per difficoltà generali della vita',
    experienceItem3: 'Programma di formazione genitoriale islamica progettato per creare famiglie equilibrate e armoniose',
    experienceItem4: 'Ricerca e pratica clinica in neurofisiologia e sviluppo infantile',
    experienceIslamic: 'I miei studi nel Corano e negli Hadith mi permettono di incorporare insegnamenti islamici autentici nella terapia, assicurando che ogni sessione sia radicata nel Deen per rafforzare sia il benessere mentale che la fede.',
    
    // Specializations
    specializationsTitle: 'Aree di Specializzazione',
    specializationsIntro: 'Competenza dettagliata per affrontare le tue esigenze specifiche con la saggezza islamica',
    neurodivergentTitle: 'Supporto Neurodivergente',
    neurodivergentDesc: 'Supporto specializzato per individui con condizioni del neurosviluppo (ADHD, Autismo) e differenze di apprendimento (dislessia, disgrafia, disortografia, discalculia e altre disabilità dell\'apprendimento). Il nostro approccio si concentra sulla comprensione delle forze uniche fornendo strategie efficaci per le sfide quotidiane.',
    multiculturalTitle: 'Relazioni Multiculturali',
    multiculturalDesc: 'Specializzato nel supportare coppie e famiglie da contesti culturali misti, aiutandoli a navigare le differenze e costruire un terreno comune con comprensione.',
    eatingDisordersTitle: 'Disturbi Alimentari',
    eatingDisordersDesc: 'Esperienza nel trattamento di disturbi alimentari e dell\'alimentazione, specificamente ARFID (Disturbo Evitante/Restrittivo dell\'Assunzione di Cibo) con approcci compassionevoli e basati sull\'evidenza.',
    therapeuticTitle: 'Approcci Terapeutici',
    therapeuticDesc: 'Certificato in Neurofeedback e Terapia Orticolturale, offrendo approcci innovativi che completano i metodi di consulenza tradizionali.',
    
    // Testimonials
    testimonialsTitle: 'Testimonianze',
    testimonialsIntro: 'Storie reali di guarigione e crescita dalla nostra comunità',
    
    // Booking
    bookingTitle: 'Dettagli delle Sessioni e Prenotazione',
    sessionDuration: 'Le sessioni durano 50 minuti',
    sessionPricing: 'Tutte le sessioni (individuali, di coppia e familiari) hanno lo stesso prezzo – Il mio obiettivo non è il guadagno finanziario ma aiutare la comunità a prosperare sia nella Dunya che nell\'Akhirah',
    freeConsultation: 'Consulenza gratuita di 15 minuti disponibile prima di impegnarsi nelle sessioni complete',
    easyScheduling: 'Programmazione Facile',
    schedulingDesc: 'Il nostro sistema di calendario integrato ti permette di selezionare orari di appuntamento che si adattano al tuo programma, con opzioni per sessioni virtuali e di persona.',
    getStarted: 'Inizia',
    getStartedDesc: 'Completa il modulo di contatto per iniziare il tuo viaggio verso il benessere mentale e la crescita spirituale.',
    fillForm: 'Compila il Modulo di Contatto',
    
    // Modal Form
    contactForm: 'Modulo di Contatto',
    formDescription: 'Per favore compila il modulo sottostante, e risponderò personalmente alla tua richiesta entro 24 ore, insha\'Allah.',
    fullName: 'Nome Completo',
    emailAddress: 'Indirizzo Email',
    phoneNumber: 'Numero di Telefono',
    message: 'Messaggio',
    messagePlaceholder: 'Per favore descrivi per cosa stai cercando aiuto',
    sendMessage: 'Invia Messaggio',
    sending: 'Invio in corso...',
    privacyNote: 'Le tue informazioni sono mantenute private e riservate',
    successMessage: 'Grazie per il tuo messaggio. Ti risponderò presto, insha\'Allah.',
    errorMessage: 'C\'è stato un errore nell\'invio del tuo modulo. Per favore riprova.',
    
    // Service tags in testimonials
    individualTherapyTag: 'Consulenza Individuale',
    familyCounselingTag: 'Consulenza Familiare',
    
    // Footer
    footerAboutTitle: 'Al-Shifaa',
    footerAboutText: 'Psicologia basata sulla fede che integra i principi islamici con la scienza moderna per il benessere mentale e la crescita spirituale.',
    footerQuickLinks: 'Link Rapidi',
    footerContact: 'Informazioni di Contatto',
    footerEmail: 'Email: info@alshifaaonline.com',
    footerSchedule: 'Programma una consulenza',
    footerCopyright: '© 2025 Al-Shifaa. Tutti i diritti riservati.',
    footerMadeWith: 'Fatto con ❤️ per la comunità musulmana'
  },
  fa: {
    // Header
    logo: 'الشفاء',
    aboutUs: 'درباره ما',
    services: 'خدمات',
    contactUs: 'تماس با ما',
    bookNow: 'رزرو نوبت',
    
    // Hero Section
    heroTitle: 'مسیر شما به سلامت روان از طریق ایمان',
    heroMessage1: 'ادغام اصول اسلامی با علم روانشناسی مدرن',
    heroMessage2: 'استفاده از دین ما به عنوان پایه‌ای برای شفا و تعادل',
    heroMessage3: 'ساختن خانواده‌های قوی از طریق روابط محوریت ایمان',
    bookConsultation: 'رزرو مشاوره',
    exploreServices: 'کاوش خدمات',
    
    // About Section
    aboutTitle: 'چرا الشفاء را ایجاد کردم',
    aboutText1: 'الهام من برای تأسیس الشفاء از علاقه عمیق من به کمک به جامعه مسلمان و تشخیص نیاز فوری به رویکردی مبتنی بر ایمان به روانشناسی می‌آید. چالش‌هایی که ما به عنوان مسلمانان با آن مواجه هستیم - چه در ازدواج، فرزندپروری یا رشد شخصی - نیازمند دیدگاهی است که اصول اسلامی را با علم روانشناسی مدرن ادغام کند.',
    aboutText2: 'روانشناسی غربی، اگرچه ارزشمند است، اغلب ملاحظات مذهبی، اخلاقی و معنوی منحصر به فردی را که مبارزات روزانه ما را شکل می‌دهد، مورد توجه قرار نمی‌دهد. اسلام یک شیوه زندگی کامل است که راهنمایی عمیق برای رفاه عاطفی و روانی ارائه می‌دهد. هدف من کمک به افراد، زوج‌ها و خانواده‌ها برای استفاده از دین ما به عنوان پایه‌ای برای شفا و تعادل همراه با گنجاندن شیوه‌های روانشناختی مبتنی بر شواهد است.',
    aboutText3: 'یک خانواده قوی با یک زوج قوی شروع می‌شود. وقتی زن و شوهر در ایمان و درک متقابل ریشه دارند، می‌توانند خانواده‌ای پررونق و هماهنگ پرورش دهند.',
    
    // Qualifications
    qualificationsTitle: 'رویکرد و صلاحیت‌های من',
    qualificationsIntro: 'آنچه رویکرد مشاوره من را متمایز می‌کند، توانایی من در پل زدن بین حکمت اسلامی و روانشناسی است',
    degree1: 'مدرک در علوم و تکنیک‌های روانشناختی',
    degree2: 'فوق‌لیسانس روانشناسی بالینی',
    degree3: 'تخصص در روان‌درمانی (در حال انجام)',
    
    // Services
    servicesTitle: 'خدمات ما',
    servicesIntro: 'خدمات جامع سلامت روان متناسب با نیازهای منحصر به فرد و ارزش‌های اسلامی شما',
    individualTherapy: 'درمان فردی',
    individualDesc: 'جلسات مشاوره انفرادی طراحی شده برای رسیدگی به چالش‌های شخصی، مشکلات عاطفی و رشد معنوی.',
    couplesTherapy: 'مشاوره زوج‌ها',
    couplesDesc: 'ازدواج خود را از طریق مشاوره‌ای که پایه اسلامی رابطه شما را گرامی می‌دارد، تقویت کنید.',
    familyTherapy: 'درمان خانوادگی',
    familyDesc: 'محیط خانوادگی هماهنگی مبتنی بر تعالیم و ارزش‌های اسلامی بسازید.',
    parentCoaching: 'مربی‌گری والدین',
    parentDesc: 'مهارت‌های فرزندپروری مؤثری که با ارزش‌های اسلامی و اصول مدرن رشد کودک همسو است را توسعه دهید.',
    
    // Special Program
    specialProgramTitle: 'برنامه ویژه: دوره آموزش والدین اسلامی',
    specialProgramSessions: '۱۰ جلسه',
    specialProgramDesc: 'این دوره منحصر به فرد برای کمک به والدین در اصلاح رفتارهای مشکل‌ساز در خود و فرزندانشان طراحی شده است تا خانواده‌ای واقعاً متعادل و هماهنگ ایجاد کنند.',
    programFeature1: 'تکنیک‌های فرزندپروری محور ایمان',
    programFeature2: 'استراتژی‌های عملی برای چالش‌های رایج',
    programFeature3: 'ساختن روابط قوی والد-فرزند',
    programFeature4: 'متعادل کردن انضباط با شفقت',
    learnMore: 'بیشتر درباره این برنامه بدانید',
    
    // Experience
    experienceTitle: 'تجربه گسترده',
    experienceItem1: 'کودکان با نیازهای ویژه شامل اوتیسم، ADHD و ناتوانی‌های یادگیری',
    experienceItem2: 'مشاوره زوج و خانواده برای موارد بیماری‌زا و مشکلات عمومی زندگی',
    experienceItem3: 'برنامه آموزش والدین اسلامی طراحی شده برای ایجاد خانواده‌های متعادل و هماهنگ',
    experienceItem4: 'تحقیق و عمل بالینی در نوروفیزیولوژی و رشد کودک',
    experienceIslamic: 'مطالعات من در قرآن و حدیث به من اجازه می‌دهد تعالیم معتبر اسلامی را در درمان گنجانده و اطمینان حاصل کنم که هر جلسه در دین ریشه دارد تا هم رفاه روانی و هم ایمان را تقویت کند.',
    
    // Specializations
    specializationsTitle: 'زمینه‌های تخصص',
    specializationsIntro: 'تخصص دقیق برای رسیدگی به نیازهای خاص شما با حکمت اسلامی',
    neurodivergentTitle: 'حمایت از نوروتفاوت',
    neurodivergentDesc: 'حمایت تخصصی برای افراد با شرایط رشد عصبی (ADHD، اوتیسم) و تفاوت‌های یادگیری (نارساخوانی، نارسانویسی، نارساهجی، نارساشماری و سایر ناتوانی‌های یادگیری). رویکرد ما بر درک نقاط قوت منحصر به فرد متمرکز است در حالی که استراتژی‌های مؤثر برای چالش‌های روزانه ارائه می‌دهد.',
    multiculturalTitle: 'روابط چندفرهنگی',
    multiculturalDesc: 'متخصص در حمایت از زوج‌ها و خانواده‌ها از پیشینه‌های فرهنگی مختلط، کمک به آنها برای حل تفاوت‌ها و ایجاد زمینه مشترک با درک.',
    eatingDisordersTitle: 'اختلالات خوردن',
    eatingDisordersDesc: 'تجربه در درمان اختلالات تغذیه و خوردن، به طور خاص ARFID (اختلال اجتنابی/محدودکننده مصرف غذا) با رویکردهای دلسوزانه و مبتنی بر شواهد.',
    therapeuticTitle: 'رویکردهای درمانی',
    therapeuticDesc: 'دارای گواهی در نوروفیدبک و درمان باغبانی، ارائه رویکردهای نوآورانه که روش‌های مشاوره سنتی را تکمیل می‌کند.',
    
    // Testimonials
    testimonialsTitle: 'شهادت‌نامه‌ها',
    testimonialsIntro: 'داستان‌های واقعی شفا و رشد از جامعه ما',
    
    // Testimonials content
    testimonial1: 'اخیراً در رابطه‌ای بودم که چهار سال طول کشید. مردی که دوستش داشتم مرا برای ازدواج یا رابطه جدی نمی‌خواست. این موضوع مرا بسیار ناراحت کرد و نمی‌توانستم تصمیم درستی درباره رابطه‌ام بگیرم. خدا را شکر که با کمک مشاوره عالی دکتر دنیا، توانستم مسیر درست زندگی‌ام را پیدا کنم و سرانجام پس از چهار سال این رابطه سمی را پایان دهم.',
    testimonial2: 'من و همسرم از خانواده مذهبی هستیم و ده سال پیش با دختر و پسرمان به آمریکا مهاجرت کردیم. پس از چند سال زندگی در میشیگان، دخترم که حالا پانزده ساله است، تحت تأثیر رفتارهای دوستانش، تمایل به رعایت حجاب را از دست داد. من و همسرم مدام با او دعوا می‌کردیم و رابطه‌مان به طور قابل توجهی بدتر شد. وقتی فهمیدم که دنیا مشاوره خانوادگی با درک کاملی از اصول اسلامی ارائه می‌دهد، این مسئله را به او آوردیم و خوشبختانه توانستیم رویکرد مناسبی با دخترمان اتخاذ کنیم. من و همسرم همیشه از او ممنون خواهیم بود.',
    testimonial3: 'از دکتر دنیا برای پسرم که اخیراً نمی‌توانست روی درسش تمرکز کند، مشاوره گرفتم و از جلسات مشاوره بسیار راضی بودم.',
    testimonial4: 'مشاوره عالی بود. دکتر دنیا به زبان مادری من صحبت کرد و ارتباط گرم و دوستانه‌ای با او احساس کردم.',
    testimonial5: 'ما برای مدتی در خانواده‌مان با مشکلات ارتباطی دست و پنجه نرم می‌کردیم. من و همسرم مشکل در برقراری ارتباط داشتیم و دختر نوجوانمان روز به روز دورتر می‌شد. وقتی تصمیم گرفتیم مشاوره بگیریم، خوشبختانه دنیا را پیدا کردیم که به ما کمک کرد بهتر ارتباط برقرار کنیم و دیدگاه یکدیگر را درک کنیم. درک او از پویایی‌های خانوادگی و رویکرد گرم او تفاوت بزرگی در رابطه‌مان ایجاد کرد. اکنون ما به عنوان یک خانواده بسیار متحدتر هستیم و همه اینها را مدیون او هستیم.',
    testimonial6: 'دوره سختی از تردید و اعتماد به نفس پایین پس از یک سری شکست‌های شخصی را می‌گذراندم. هیچ ایده‌ای نداشتم که کجا بروم یا چگونه شفا شروع کنم. جلسات درمانی دکتر دنیا به من کمک کرد احساساتم را کاوش کنم، ارزش خودم را درک کنم و مکانیسم‌های مقابله‌ای سالم‌تر توسعه دهم. صبر و توصیه‌های بصیرانه او تأثیر فوق‌العاده‌ای بر زندگی من داشته است. اکنون احساس اعتماد به نفس بیشتری دارم و برای مواجهه با چالش‌ها آماده‌ام. واقعاً از راهنمایی او سپاسگزارم.',
    testimonial7: 'من و همسرم با پسر کوچکمان که رفتار پرخاشگرانه داشت و در مدرسه مشکل داشت، مواجه بودیم. مطمئن نبودیم چگونه با این وضعیت برخورد کنیم و نگران آینده او بودیم. پس از تماس با دکتر دنیا برای مشاوره خانوادگی، او ابزارهای ارزشمندی برای بهبود فرزندپروری و تقویت پیوند ما با پسرمان به ما داد. رویکرد دلسوزانه و محترمانه او تمام تفاوت را ایجاد کرد. اکنون احساس کنترل بیشتری داریم و نسبت به پیشرفت او امیدوارتریم. متشکریم دکتر دنیا!',
    testimonial8: 'احساس غرق شدن در استرس و اضطراب به دلیل کار و زندگی شخصی‌ام داشتم و مدیریت همه چیز برایم سخت بود. یک دوست دکتر دنیا را توصیه کرد و پس از چند جلسه، شروع به تغییر قابل توجهی در طرز فکرم کردم. رویکرد درمانی او به من کمک کرد اضطرابم را مدیریت کنم و تعادل در زندگی‌ام پیدا کنم. اکنون احساس آرامش بیشتری دارم و قادرم با چالش‌های زندگی مقابله کنم. واقعاً از حمایت او متشکرم.',
    
    // Booking
    bookingTitle: 'جزئیات جلسه و رزرو',
    sessionDuration: 'جلسات ۵۰ دقیقه طول می‌کشد',
    sessionPricing: 'همه جلسات (فردی، زوج و خانوادگی) هم قیمت هستند - هدف من سود مالی نیست بلکه کمک به جامعه برای رونق در دنیا و آخرت است',
    freeConsultation: 'مشاوره رایگان ۱۵ دقیقه‌ای قبل از تعهد به جلسات کامل در دسترس است',
    easyScheduling: 'برنامه‌ریزی آسان',
    schedulingDesc: 'سیستم تقویم یکپارچه ما به شما اجازه می‌دهد زمان‌های قرار ملاقات که با برنامه شما مطابقت دارد را انتخاب کنید، با گزینه‌هایی برای جلسات مجازی و حضوری.',
    getStarted: 'شروع کنید',
    getStartedDesc: 'فرم تماس را تکمیل کنید تا سفر خود را به سوی سلامت روان و رشد معنوی آغاز کنید.',
    fillForm: 'تکمیل فرم تماس',
    
    // Modal Form
    contactForm: 'فرم تماس',
    formDescription: 'لطفاً فرم زیر را تکمیل کنید و من شخصاً ظرف ۲۴ ساعت به درخواست شما پاسخ خواهم داد، ان‌شاءالله.',
    fullName: 'نام کامل',
    emailAddress: 'آدرس ایمیل',
    phoneNumber: 'شماره تلفن',
    message: 'پیام',
    messagePlaceholder: 'لطفاً توضیح دهید که برای چه چیزی به دنبال کمک هستید',
    sendMessage: 'ارسال پیام',
    sending: 'در حال ارسال...',
    privacyNote: 'اطلاعات شما خصوصی و محرمانه نگه داشته می‌شود',
    successMessage: 'متشکرم از پیام شما. به زودی پاسخ خواهم داد، ان‌شاءالله.',
    errorMessage: 'خطایی در ارسال فرم شما رخ داد. لطفاً دوباره تلاش کنید.',
    
    // Service tags in testimonials
    individualTherapyTag: 'درمان فردی',
    familyCounselingTag: 'مشاوره خانوادگی',
    
    // Footer
    footerAboutTitle: 'الشفاء',
    footerAboutText: 'روانشناسی مبتنی بر ایمان که اصول اسلامی را با علم مدرن برای سلامت روان و رشد معنوی ادغام می‌کند.',
    footerQuickLinks: 'لینک‌های سریع',
    footerContact: 'اطلاعات تماس',
    footerEmail: 'ایمیل: info@alshifaaonline.com',
    footerSchedule: 'زمان‌بندی مشاوره',
    footerCopyright: '© ۲۰۲۵ الشفاء. تمام حقوق محفوظ است.',
    footerMadeWith: 'ساخته شده با ❤️ برای جامعه مسلمان'
  }
};

// Custom hook for scroll animations
const useScrollAnimation = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe all elements with scroll-animate class
    const animateElements = document.querySelectorAll('.scroll-animate');
    animateElements.forEach((el) => observer.observe(el));

    return () => {
      animateElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
};

function App() {
  // State to track which service is selected
  const [selectedService, setSelectedService] = useState('individual');
  
  // Language state
  const [language, setLanguage] = useState('en');
  
  // State for form inputs
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  
  // State to control modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // State to track form submission status
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Add this state near your other useState declarations
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  
  // Add these new state variables at the top of your App component
  const [isPaused, setIsPaused] = useState(false);
  const scrollRef = useRef(null);
  
  // Splash screen state
  const [showSplash, setShowSplash] = useState(true);
  
  // Initialize scroll animations
  useScrollAnimation();
  
  // Splash screen effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 3000); // Show splash for 3 seconds
    
    return () => clearTimeout(timer);
  }, []);
  
  // Helper function to get translated text
  const t = (key) => translations[language][key] || key;
  
  // Add smooth scroll function
  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  
  // Function to get the correct image based on selected service
  const getServiceImage = () => {
    switch(selectedService) {
      case 'individual':
        return individualImage;
      case 'couples':
        return coupleImage;
      case 'family':
        return familyImage;
      case 'parent':
        return parentImage;
      default:
        return individualImage;
    }
  };
  
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  // Update the form submission handler to use FormSpark
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Show loading state
    setIsSubmitting(true);
    
    try {
      // Submit form data to FormSpark
      await fetch("https://submit-form.com/TYIzBl6Va", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });
      
      // Reset form after submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      
      // Close modal and show success message
      setIsModalOpen(false);
      alert(t('successMessage'));
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(t('errorMessage'));
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // Open modal
  const openModal = () => {
    setIsModalOpen(true);
    // Prevent body scrolling when modal is open
    document.body.style.overflow = 'hidden';
  };
  
  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    // Re-enable body scrolling
    document.body.style.overflow = 'auto';
  };
  
  // Add this new useEffect for automatic scrolling
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let scrollInterval;
    
    const startScrolling = () => {
      scrollInterval = setInterval(() => {
        if (!isPaused) {
          const isAtEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth;
          if (isAtEnd) {
            // Reset to start with smooth scrolling
            scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            // Scroll to next testimonial
            scrollContainer.scrollBy({ left: 800, behavior: 'smooth' });
          }
        }
      }, 5000); // Scroll every 5 seconds
    };

    startScrolling();

    // Cleanup
    return () => {
      if (scrollInterval) clearInterval(scrollInterval);
    };
  }, [isPaused]);
  
  return (
    <div className={`App ${language === 'fa' ? 'rtl' : ''}`}>
      {/* Splash Screen */}
      {showSplash && (
        <div className="splash-screen">
          <div className="splash-content">
            <img 
              src={logoImage} 
              alt="Al-Shifaa Logo" 
              className="splash-logo"
            />
            <div className="splash-text">Al-Shifaa</div>
            <div className="splash-tagline">Faith-based Mental Health Counseling</div>
          </div>
        </div>
      )}
      
      {/* Main Website Content */}
      <div className={`main-content ${showSplash ? 'hidden' : 'visible'}`}>
        {/* Separate Language Switcher Header */}
        <div className="language-header">
          <div className="language-switcher-small">
            <button 
              className={`lang-btn-small ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              EN
            </button>
            <button 
              className={`lang-btn-small ${language === 'it' ? 'active' : ''}`}
              onClick={() => setLanguage('it')}
            >
              IT
            </button>
            <button 
              className={`lang-btn-small ${language === 'fa' ? 'active' : ''}`}
              onClick={() => setLanguage('fa')}
            >
              فا
            </button>
          </div>
        </div>
        
        <header className="floating-header">
          <div className="header-container">
            <div className="logo">
              <img src={logoImage} alt="Al-Shifaa Logo" className="logo-image" />
            </div>
            
            <nav className="main-nav">
              <a href="#about" onClick={(e) => { e.preventDefault(); smoothScrollTo('about'); }}>{t('aboutUs')}</a>
              <a href="#services" onClick={(e) => { e.preventDefault(); smoothScrollTo('services'); }}>{t('services')}</a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); smoothScrollTo('footer'); }}>{t('contactUs')}</a>
            </nav>
            <a 
              href="https://calendly.com/info-alshifaaonline" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="book-now"
            >
              {t('bookNow')}
            </a>
          </div>
        </header>
        
        <div className="hero-section">
          <div className="hero-content">
            <div className="hero-left">
              <h1 className="scroll-animate fade-in-up">{t('heroTitle')}</h1>
              
              <div className="key-messages">
                <p className="message-line scroll-animate fade-in-up delay-1">{t('heroMessage1')}</p>
                <p className="message-line scroll-animate fade-in-up delay-2">{t('heroMessage2')}</p>
                <p className="message-line scroll-animate fade-in-up delay-3">{t('heroMessage3')}</p>
              </div>
              
              <div className="hero-buttons scroll-animate fade-in-up delay-4">
                <a 
                  href="https://calendly.com/info-alshifaaonline" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hero-cta primary-btn"
                >
                  {t('bookConsultation')}
                </a>
                <button className="hero-cta secondary-btn">{t('exploreServices')}</button>
              </div>
            </div>
            
            <div className="hero-right">
              <div className="blob-animation"></div>
              <div className="image-container scroll-animate fade-in-right">
                <img src={backgroundImage} alt="Mental wellness" />
              </div>
            </div>
          </div>
        </div>
        
        <section className="about-section" id="about">
          <div className="about-container">
            <div className="about-image scroll-animate fade-in-left">
              <img src={illustrationImage} alt="Islamic mental wellness illustration" />
            </div>
            
            <div className="about-content">
              <h2 className="scroll-animate fade-in-up">{t('aboutTitle')}</h2>
              
              <p className="scroll-animate fade-in-up delay-1">{t('aboutText1')}</p>
              
              <p className="scroll-animate fade-in-up delay-2">{t('aboutText2')}</p>
              
              <p className="scroll-animate fade-in-up delay-3">{t('aboutText3')}</p>
            </div>
          </div>
        </section>
        
        <section className="qualifications-section" id="qualifications">
          <div className="qualifications-container">
            <h2 className="scroll-animate fade-in-up">{t('qualificationsTitle')}</h2>
            <p className="qualifications-intro scroll-animate fade-in-up delay-1">{t('qualificationsIntro')}</p>
            
            <div className="education-container">
              <div className="education-degrees">
                <div className="degree-card scroll-animate fade-in-up delay-1">
                  <div className="degree-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="24" height="24" fill="currentColor">
                      <path d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"/>
                    </svg>
                  </div>
                  <h3>{t('degree1')}</h3>
                </div>
                
                <div className="degree-card scroll-animate fade-in-up delay-2">
                  <div className="degree-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24" height="24" fill="currentColor">
                      <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/>
                    </svg>
                  </div>
                  <h3>{t('degree2')}</h3>
                </div>
                
                <div className="degree-card scroll-animate fade-in-up delay-3">
                  <div className="degree-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="24" height="24" fill="currentColor">
                      <path d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"/>
                    </svg>
                  </div>
                  <h3>{t('degree3')}</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="services-section" id="services">
          <div className="services-container">
            <h2 className="scroll-animate fade-in-up">{t('servicesTitle')}</h2>
            <p className="services-intro scroll-animate fade-in-up delay-1">{t('servicesIntro')}</p>
            
            <div className="interactive-services">
              <div className="service-image-wrapper scroll-animate fade-in-left delay-2">
                <img src={getServiceImage()} alt="Service illustration" className="service-main-image" />
              </div>
              
              <div className="service-list">
                <div 
                  className={`service-list-item scroll-animate fade-in-right delay-1 ${selectedService === 'individual' ? 'active' : ''}`}
                  onClick={() => setSelectedService('individual')}
                >
                  <div className="service-info">
                    <h3>{t('Individual Counselling')}</h3>
                    <p>{t('individualDesc')}</p>
                  </div>
                  <div className="service-arrow">→</div>
                </div>
                
                <div 
                  className={`service-list-item scroll-animate fade-in-right delay-2 ${selectedService === 'couples' ? 'active' : ''}`}
                  onClick={() => setSelectedService('couples')}
                >
                  <div className="service-info">
                    <h3>{t('Couples Counselling')}</h3>
                    <p>{t('couplesDesc')}</p>
                  </div>
                  <div className="service-arrow">→</div>
                </div>
                
                <div 
                  className={`service-list-item scroll-animate fade-in-right delay-3 ${selectedService === 'family' ? 'active' : ''}`}
                  onClick={() => setSelectedService('family')}
                >
                  <div className="service-info">
                    <h3>{t('Family Counselling')}</h3>
                    <p>{t('familyDesc')}</p>
                  </div>
                  <div className="service-arrow">→</div>
                </div>
                
                <div 
                  className={`service-list-item scroll-animate fade-in-right delay-4 ${selectedService === 'parent' ? 'active' : ''}`}
                  onClick={() => setSelectedService('parent')}
                >
                  <div className="service-info">
                    <h3>{t('Parent Training')}</h3>
                    <p>{t('parentDesc')}</p>
                  </div>
                  <div className="service-arrow">→</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="special-program-section" id="special-program">
          <div className="special-program-container">
            <div className="special-program-content">
              <h2 className="scroll-animate fade-in-up">{t('specialProgramTitle')}</h2>
              <div className="session-count scroll-animate fade-in-up delay-1">{t('specialProgramSessions')}</div>
              <p className="scroll-animate fade-in-up delay-2">{t('specialProgramDesc')}</p>
              
              <div className="program-features">
                <div className="program-feature scroll-animate fade-in-up delay-3">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">{t('programFeature1')}</div>
                </div>
                <div className="program-feature scroll-animate fade-in-up delay-4">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">{t('programFeature2')}</div>
                </div>
                <div className="program-feature scroll-animate fade-in-up delay-5">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">{t('programFeature3')}</div>
                </div>
                <div className="program-feature scroll-animate fade-in-up delay-6">
                  <div className="feature-icon">✓</div>
                  <div className="feature-text">{t('programFeature4')}</div>
                </div>
              </div>
              
              <a 
                href="https://calendly.com/info-alshifaaonline" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="program-cta scroll-animate bounce-in delay-4"
              >
                {t('learnMore')}
              </a>
            </div>
            
            <div className="special-program-image scroll-animate fade-in-right delay-2">
              <img src={sessionImage} alt="Islamic Parent Training Course" />
            </div>
          </div>
        </section>
        
        <section className="experience-section" id="experience">
          <div className="experience-container">
            <div className="experience-image scroll-animate fade-in-left">
              <img src={experienceImage} alt="Extensive experience in Islamic counselling" />
            </div>
            
            <div className="experience-content">
              <h2 className="scroll-animate fade-in-up">{t('experienceTitle')}</h2>
              
              <div className="experience-list">
                <div className="experience-item scroll-animate fade-in-up delay-1">
                  <div className="check-icon">✅</div>
                  <p><strong>{t('experienceItem1')}</strong></p>
                </div>
                
                <div className="experience-item scroll-animate fade-in-up delay-2">
                  <div className="check-icon">✅</div>
                  <p><strong>{t('experienceItem2')}</strong></p>
                </div>
                
                <div className="experience-item scroll-animate fade-in-up delay-3">
                  <div className="check-icon">✅</div>
                  <p><strong>{t('experienceItem3')}</strong></p>
                </div>
                
                <div className="experience-item scroll-animate fade-in-up delay-4">
                  <div className="check-icon">✅</div>
                  <p><strong>{t('experienceItem4')}</strong></p>
                </div>
              </div>
              
              <div className="islamic-education scroll-animate fade-in-up delay-5">
                <p>{t('experienceIslamic')}</p>
              </div>
            </div>
          </div>
        </section>
        
        {/* New Specialization Cards Section */}
        <section className="specialization-section">
          <div className="specialization-container">
            <h2 className="scroll-animate fade-in-up">{t('specializationsTitle')}</h2>
            <p className="specialization-intro scroll-animate fade-in-up delay-1">{t('specializationsIntro')}</p>
            
            <div className="specialization-cards">
              <div className="specialization-card scroll-animate card-animate delay-1">
                <div className="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="40" height="40" fill="#0f3e2c">
                    <path d="M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"/>
                  </svg>
                </div>
                <div className="specialization-card-content">
                  <h3>{t('neurodivergentTitle')}</h3>
                  <p>{t('neurodivergentDesc')}</p>
                </div>
              </div>
              
              <div className="specialization-card scroll-animate card-animate delay-2">
                <div className="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="40" height="40" fill="#0f3e2c">
                    <path d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"/>
                  </svg>
                </div>
                <div className="specialization-card-content">
                  <h3>{t('multiculturalTitle')}</h3>
                  <p>{t('multiculturalDesc')}</p>
                </div>
              </div>
              
              <div className="specialization-card scroll-animate card-animate delay-3">
                <div className="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="40" height="40" fill="#0f3e2c">
                    <path d="M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"/>
                  </svg>
                </div>
                <div className="specialization-card-content">
                  <h3>{t('eatingDisordersTitle')}</h3>
                  <p>{t('eatingDisordersDesc')}</p>
                </div>
              </div>
              
              <div className="specialization-card scroll-animate card-animate delay-4">
                <div className="card-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="40" height="40" fill="#0f3e2c">
                    <path d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"/>
                  </svg>
                </div>
                <div className="specialization-card-content">
                  <h3>{t('therapeuticTitle')}</h3>
                  <p>{t('therapeuticDesc')}</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="testimonials-container">
            <h2 className="section-title scroll-animate fade-in-up">{t('testimonialsTitle')}</h2>
            
            <div className="testimonials-wrapper scroll-animate fade-in-up delay-1">
              <button 
                className="scroll-arrow left" 
                onClick={() => scrollRef.current?.scrollBy({ left: -800, behavior: 'smooth' })}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              <div 
                className="testimonials-scroll"
                ref={scrollRef}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
              >
                <div className="testimonial-item">
                  <p className="testimonial-text">
                    I had recently been in a relationship that lasted four years. The guy I loved didn't want me for marriage or a serious relationship. This made me extremely upset, and I couldn't make the right decision about my relationship. I thank God that, with the help of Dr. Amenta's great counselling, I was able to find the right path for my life and finally end this toxic relationship after four years.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Fatima</div>
                      <div className="author-location">Italy</div>
                    </div>
                    <div className="testimonial-service">{t('individualTherapyTag')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    My husband and I come from a religious family, and we immigrated to America ten years ago with our daughter and son. After living in Michigan for a few years, my daughter, who is now fifteen, lost her desire to observe hijab under the influence of her friends' behaviors. My husband and I were constantly arguing with her, and our relationship deteriorated significantly. When I learned that Dr. Amenta provides counselling for families with a complete understanding of Islamic principles, we brought this issue to her, and fortunately, we were able to adopt an appropriate approach with our daughter. My husband and I will always be grateful to her.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Zeynab</div>
                      <div className="author-location">USA</div>
                    </div>
                    <div className="testimonial-service">{t('family Counseling')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    I received counselling from Dr. Amenta for my son, who recently couldn't focus enough on his studies, and I was very satisfied with the counselling sessions.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Yasin</div>
                      <div className="author-location">USA</div>
                    </div>
                    <div className="testimonial-service">{t('family Counseling')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    The counselling was excellent. Dr. Amenta spoke to me in my native language, and I felt a warm and friendly connection with her.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Khadija</div>
                      <div className="author-location">Iran</div>
                    </div>
                    <div className="testimonial-service">{t('family Counseling')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    We have been struggling with communication issues in our family for quite some time. My husband and I were finding it difficult to connect, and our teenage daughter was becoming more distant. When we decided to seek counselling, we were fortunate to find Dr. Amenta, who helped us communicate better and understand each other's perspectives. Her understanding of family dynamics and her warm approach made a big difference in our relationship. We're now much more united as a family, and we owe it all to her.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Sara and Ali</div>
                      <div className="author-location">Canada</div>
                    </div>
                    <div className="testimonial-service">{t('family Counseling')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    I was going through a tough period of self-doubt and low self-esteem after a series of personal setbacks. I had no idea where to turn or how to start healing. Dr. Amenta's Individual counselling sessions helped me explore my feelings, understand my worth, and develop healthier coping mechanisms. Her patience and insightful advice have made a tremendous impact on my life. I feel more confident and equipped to face challenges now. I am truly grateful for her guidance.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Miriam</div>
                      <div className="author-location">UK</div>
                    </div>
                    <div className="testimonial-service">{t('individualTherapyTag')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    My husband and I were facing challenges with our young son, who was acting out and struggling at school. We weren't sure how to approach the situation and were worried about his future. After reaching out to Dr. Amenta for family counselling, she gave us invaluable tools for improving our parenting and strengthening our bond with our son. Her compassionate and respectful approach made all the difference. We feel much more in control and hopeful about his progress. Thank you, Dr. Amenta!
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Reza and Niloofar</div>
                      <div className="author-location">Australia</div>
                    </div>
                    <div className="testimonial-service">{t('family Counseling')}</div>
                  </div>
                </div>

                <div className="testimonial-divider"></div>

                <div className="testimonial-item">
                  <p className="testimonial-text">
                    I had been feeling overwhelmed by stress and anxiety due to my job and personal life, and I found it difficult to manage everything. A friend recommended Dr. Amenta, and after a few sessions, I began to notice a significant change in my mindset. Her therapeutic approach helped me manage my anxiety and find balance in my life. I now feel much more at peace and capable of handling life's challenges. I'm truly thankful for her support.
                  </p>
                  <div className="testimonial-footer">
                    <div className="testimonial-author">
                      <div className="author-name">Laila</div>
                      <div className="author-location">Italy</div>
                    </div>
                    <div className="testimonial-service">{t('individualTherapyTag')}</div>
                  </div>
                </div>
              </div>

              <button 
                className="scroll-arrow right" 
                onClick={() => scrollRef.current?.scrollBy({ left: 800, behavior: 'smooth' })}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </section>
        
        <section className="booking-section" id="booking">
          <div className="booking-container">
            <h2 className="scroll-animate fade-in-up">{t('bookingTitle')}</h2>
            
            <div className="booking-content">
              <div className="booking-info">
                <div className="booking-image scroll-animate fade-in-left delay-1">
                  <img src={bookingImage} alt="Booking a counselling session" />
                </div>
                
                <div className="session-details">
                  <div className="session-duration-pill scroll-animate fade-in-up delay-1">{t('sessionDuration')}</div>
                  
                  <ul className="session-list scroll-animate fade-in-up delay-2">
                    <li><span className="session-pricing"><strong>{t('sessionPricing')}</strong></span></li>
                    <li><span className="free-consultation"><strong>{t('freeConsultation')}</strong></span></li>
                  </ul>
                  
                  <div className="booking-process scroll-animate fade-in-up delay-3">
                    <div className="booking-step">
                      <div className="step-icon">📅</div>
                      <div className="step-content">
                        <h4>{t('easyScheduling')}</h4>
                        <p>{t('schedulingDesc')}</p>
                      </div>
                    </div>
                    
                    <div className="booking-step">
                      <div className="step-icon">📩</div>
                      <div className="step-content">
                        <h4>{t('getStarted')}</h4>
                        <p>{t('getStartedDesc')}</p>
                      </div>
                    </div>
                  </div>
                  
                  <a 
                    href="https://calendly.com/info-alshifaaonline" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="open-form-button"
                  >
                    {t('bookNow')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* Footer */}
        <footer className="footer-section" id="footer">
          <div className="footer-container">
            <div className="footer-content">
              <div className="footer-about">
                <h3>{t('footerAboutTitle')}</h3>
                <p>{t('footerAboutText')}</p>
              </div>
              
              <div className="footer-links">
                <h4>{t('footerQuickLinks')}</h4>
                <ul>
                  <li><a href="#about">{t('aboutUs')}</a></li>
                  <li><a href="#services">{t('services')}</a></li>
                  <li><a href="#booking">{t('contactUs')}</a></li>
                  <li>
                    <a 
                      href="https://calendly.com/info-alshifaaonline" 
                      target="_blank" 
                      rel="noopener noreferrer"
                    >
                      {t('footerSchedule')}
                    </a>
                  </li>
                </ul>
              </div>
              
              <div className="footer-contact">
                <h4>{t('footerContact')}</h4>
                <p>{t('footerEmail')}</p>
                <a 
                  href="https://calendly.com/info-alshifaaonline" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-book-btn"
                >
                  {t('bookNow')}
                </a>
              </div>
            </div>
            
            <div className="footer-bottom">
              <div className="footer-copyright">
                <p>{t('footerCopyright')}</p>
              </div>
              <div className="footer-made-with">
                <p>{t('footerMadeWith')}</p>
              </div>
            </div>
          </div>
        </footer>
        
        {/* Modal Form */}
        {isModalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-container" onClick={(e) => e.stopPropagation()}>
              <button className="close-modal" onClick={closeModal}>×</button>
              
              <div className="modal-header">
                <h3>{t('contactForm')}</h3>
              </div>
              
              <div className="modal-content">
                <div className="islamic-decoration decoration-top-right"></div>
                <div className="islamic-decoration decoration-bottom-left"></div>
                
                <div className="bismillah">بسم الله الرحمن الرحيم</div>
                
                <p className="modal-description">{t('formDescription')}</p>
                
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">{t('fullName')}</label>
                    <input 
                      type="text" 
                      id="name" 
                      name="name" 
                      value={formData.name}
                      onChange={handleInputChange}
                      required 
                      placeholder={t('fullName')}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">{t('emailAddress')}</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email" 
                      value={formData.email}
                      onChange={handleInputChange}
                      required 
                      placeholder={t('emailAddress')}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">{t('phoneNumber')}</label>
                    <input 
                      type="tel" 
                      id="phone" 
                      name="phone" 
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder={t('phoneNumber')}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">{t('message')}</label>
                    <textarea 
                      id="message" 
                      name="message" 
                      rows="5" 
                      value={formData.message}
                      onChange={handleInputChange}
                      required
                      placeholder={t('messagePlaceholder')}
                    ></textarea>
                  </div>
                  
                  <button 
                    type="submit" 
                    className="submit-button" 
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? t('sending') : t('sendMessage')}
                  </button>
                  
                  <div className="form-footer">
                    <div className="privacy-note">
                      <span className="privacy-icon">🔒</span>
                      <span>{t('privacyNote')}</span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
